import { NgModule } from '@angular/core';
import { LibArrowLeftIconComponent } from './lib-arrow-left-icon.component';

@NgModule({
  declarations: [LibArrowLeftIconComponent],
  imports: [],
  exports: [LibArrowLeftIconComponent],
})
export class LibArrowLeftIconModule {}
